import React, { useState } from "react";
import { DataContext } from "../../helper/HelperOne";
import NavBar from "../nav_bar/Navbar";
import WorkersList from "./Workerslist";

function Workers() {
  const [searchUi, setSearchUi] = useState(false);
  const [searchData, setSearchData] = useState(null);

  return (
    <DataContext.Provider
      value={{ searchUi, setSearchUi, searchData, setSearchData }}
    >
      <NavBar childrenPage={<WorkersList />} menuId={9} />
    </DataContext.Provider>
  );
}

export default Workers;
